import React from 'react';

/**
 * Card: default or dense. No glassmorphism; clean surface + border.
 */
export function Card({ children, dense = false, className = '', ...props }) {
  return (
    <div
      className={`ui-card ${dense ? 'ui-card--dense' : ''} ${className}`.trim()}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ title, subtitle, action, className = '' }) {
  return (
    <div className={`ui-card__header ${className}`.trim()}>
      <div>
        {title && <h3 className="ui-card__title">{title}</h3>}
        {subtitle && <p className="ui-card__subtitle">{subtitle}</p>}
      </div>
      {action && <div className="ui-card__action">{action}</div>}
    </div>
  );
}

export function CardBody({ children, className = '' }) {
  return <div className={`ui-card__body ${className}`.trim()}>{children}</div>;
}
